import { WhatsappLogo } from '@phosphor-icons/react'
import { AGENCY, whatsappLink } from '../data/travel'

export default function QuoteCTA() {
  return (
    <section className="px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-2xl bg-sunset-500 px-7 py-12 text-white md:px-14 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-white/70">Sin compromiso</p>
            <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight md:text-5xl">
              Cuéntanos a dónde quieres ir y te decimos cuánto cuesta.
            </h2>
          </div>
          <div className="flex flex-col gap-3 lg:col-span-4 lg:items-end">
            <a
              href={whatsappLink('Hola, quiero cotizar un viaje.')}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3.5 text-sm font-semibold text-navy-950 transition-colors hover:bg-sunset-50"
            >
              <WhatsappLogo size={18} weight="fill" />
              Pedir cotización
            </a>
            <p className="text-sm text-white/75">{AGENCY.phoneDisplay}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
